import React from 'react';
import styled from 'styled-components';
import { FundsSummaryIcon } from '../../../../components/SVGs/commonSVGs';

const BannerWrapper = styled.div`
  width: calc(100vw - 27rem);
  padding: 0 4.2rem;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const BanneContainer = styled.div`
  width: 100%;
  max-width: 130rem;
  padding: 4rem 1rem;
  height: 5.75rem;
  flex-shrink: 0;
  background: linear-gradient(
    138deg,
    #ffeddc -3.4%,
    #fff4e2 49.1%,
    #fff2de 106.32%
  );
  border-radius: 2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
`;

const StyledTitle = styled.span`
  color: var(--CIDER-CIDER800, #68440f);
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.375rem;
`;

const StyledSubTitle = styled.span`
  color: var(--CIDER-CIDER800, #68440f);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  margin-top: 7px;
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
`;

const IconSection = styled.div`
  padding-left: 5px;
`;

const Banner = () => {
  return (
    <BannerWrapper>
      <BanneContainer>
        <IconSection>
          <FundsSummaryIcon />
        </IconSection>
        <ContentSection>
          <StyledTitle>
            The dashboard is currently in a view-only state
          </StyledTitle>
          <StyledSubTitle>
            Due to technical limitations, the ability to create or edit anything
            has been restricted temporarily. The functionality will be
            reinstated shortly.
          </StyledSubTitle>
        </ContentSection>
      </BanneContainer>
    </BannerWrapper>
  );
};

export default Banner;
